module.exports = __webpack_public_path__ + "img/toppop.bf7cedce.png";